export default "__VITE_ASSET__nU_wOq2w__"